<template>
  <div class="preset-container">
    <div v-if="viewTarget === screens.listPreset" class="gf__list--preset">
      <div v-for="i in 10" v-if="isLoadingPreset" :key="i" class="preset--item gf_preset-skeleton_container">
        <div class="skeleton skeleton-dark gf_preset-skeleton"></div>
      </div>
      <perfect-scrollbar v-else class="scrollBody">
        <div class="body">
          <template v-for="(preset, index) in presets">
            <PresetItem
              v-if="!preset.destroy"
              :key="index"
              :index-item="index"
              :preset="preset"
              @edit="editPreset"
              @preview="turnOnPreview"
              @duplicate="onDuplicatePreset"
              @apply-current-page="applyCurrentPage"
              @apply-other-page="applyOtherPage"
              @delete="onDeletePreset" />
          </template>
        </div>

        <GuideCustomizeStyle
          v-if="!obGlobalStyle.introducingGlobalStyle"
          title="Introducing Global Style"
          guide="introducingGlobalStyle"
          content="You can customize styles and elements to build a consistent look across your pages."
          link="https://help.gempages.net/articles/introduction-global-style" />
      </perfect-scrollbar>
      <div class="footer">
        <div
          v-if="PRICING_LIMIT_PRESET[shopInfo.plan] === MAX_PRESET_ALLOW && invalidCreateNewButton"
          v-tooltip.right="{
            content: planAlert,
            delay: 200,
            class: `limit-preset-tooltip`,
          }"
          class="preset--create">
          <span class="label">
            <svg class="plus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.375 3.625C10.375 3.34886 10.1511 3.125 9.875 3.125C9.59886 3.125 9.375 3.34886 9.375 3.625V9.625H3.625C3.34886 9.625 3.125 9.84886 3.125 10.125C3.125 10.4011 3.34886 10.625 3.625 10.625H9.375V16.375C9.375 16.6511 9.59886 16.875 9.875 16.875C10.1511 16.875 10.375 16.6511 10.375 16.375V10.625H16.375C16.6511 10.625 16.875 10.4011 16.875 10.125C16.875 9.84886 16.6511 9.625 16.375 9.625H10.375V3.625Z"
                :fill="invalidCreateNewButton ? '#757575' : '#E2E2E2'" />
            </svg>
            <button
              class="btn-create--preset !px-0"
              :class="{
                '!text-dark-mode-disabled': invalidCreateNewButton,
              }">
              Create New Preset
            </button>
            <svg
              :class="{ 'transform-y': !invalidCreateNewButton && showCreate }"
              class="arrow"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM6 6L5.64645 6.35355C5.84171 6.54882 6.15829 6.54882 6.35355 6.35355L6 6ZM11.3536 1.35355C11.5488 1.15829 11.5488 0.841709 11.3536 0.646447C11.1583 0.451184 10.8417 0.451184 10.6464 0.646447L11.3536 1.35355ZM0.646447 1.35355L5.64645 6.35355L6.35355 5.64645L1.35355 0.646447L0.646447 1.35355ZM6.35355 6.35355L11.3536 1.35355L10.6464 0.646447L5.64645 5.64645L6.35355 6.35355Z"
                :fill="invalidCreateNewButton ? '#757575' : '#E2E2E2'" />
            </svg>
          </span>
        </div>
        <div v-else v-click-away="onOutSide" class="preset--create" @click="toggleNewPresetPopup">
          <UpgradePlanPopup
            v-if="invalidCreateNewButton && showCreate"
            :limit="pricingLimitPreset"
            @on-out-side="onOutSide" />
          <span class="label">
            <svg class="plus" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.375 3.625C10.375 3.34886 10.1511 3.125 9.875 3.125C9.59886 3.125 9.375 3.34886 9.375 3.625V9.625H3.625C3.34886 9.625 3.125 9.84886 3.125 10.125C3.125 10.4011 3.34886 10.625 3.625 10.625H9.375V16.375C9.375 16.6511 9.59886 16.875 9.875 16.875C10.1511 16.875 10.375 16.6511 10.375 16.375V10.625H16.375C16.6511 10.625 16.875 10.4011 16.875 10.125C16.875 9.84886 16.6511 9.625 16.375 9.625H10.375V3.625Z"
                :fill="invalidCreateNewButton ? '#757575' : '#E2E2E2'" />
            </svg>
            <button
              class="btn-create--preset !px-0"
              :class="{
                '!text-dark-mode-disabled': invalidCreateNewButton,
              }">
              Create New Preset
            </button>
            <svg
              :class="{ 'transform-y': !invalidCreateNewButton && showCreate }"
              class="arrow"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM6 6L5.64645 6.35355C5.84171 6.54882 6.15829 6.54882 6.35355 6.35355L6 6ZM11.3536 1.35355C11.5488 1.15829 11.5488 0.841709 11.3536 0.646447C11.1583 0.451184 10.8417 0.451184 10.6464 0.646447L11.3536 1.35355ZM0.646447 1.35355L5.64645 6.35355L6.35355 5.64645L1.35355 0.646447L0.646447 1.35355ZM6.35355 6.35355L11.3536 1.35355L10.6464 0.646447L5.64645 5.64645L6.35355 6.35355Z"
                :fill="invalidCreateNewButton ? '#757575' : '#E2E2E2'" />
            </svg>
          </span>
          <PopupOnboarding
            v-if="isVisiblePopupOnboarding"
            type-o-b="createNewPreset"
            :p-style="{
              position: 'absolute',
              bottom: '57px',
              left: '16px',
            }"
            :style-arrow="{
              position: 'absolute',
              transform: 'rotate(-90deg)',
              bottom: '-14px',
              left: '30px',
            }"
            title="Create New Preset"
            content="Import directly from the current page or start with a blank preset" />
        </div>
        <div v-if="!invalidCreateNewButton && showCreate" class="create--options">
          <div
            v-tooltip.right="'We will import all available styles from your Shopify Theme to create a Preset'"
            class="option"
            @click="onLiveTheme">
            From Live Theme
          </div>
          <div
            v-tooltip.right="'All available styles from this opened page will be imported as a new Preset'"
            class="option"
            @click="onThisPage">
            From This Page
          </div>
          <div v-tooltip.right="'A new Preset comes with predefined styles'" class="option" @click="createNewPreset">
            New Preset
          </div>
        </div>
      </div>
    </div>
    <div id="menu-action" teleport></div>
    <div id="preview-onboarding" teleport></div>
    <LiveThemePreset
      v-if="viewTarget === screens.liveThemePreset"
      :type-modal="typeModal"
      @back="onBack"
      @preview-preset="previewPresetFunc" />

    <FeaturePromotionModal
      v-if="
        !obGlobalStyle.featurePromotion &&
        ((shopInfo?.passwordEnabled && shopInfo?.password) || !shopInfo?.passwordEnabled)
      " />
    <NotifyModal
      v-if="isDeleteConfirmed"
      :txt-header="txtHeader"
      :txt-description="txtDesConfirm"
      txt-button-confirm="Delete"
      confirm-class="gf_btn-delete"
      @action="actionNotify">
    </NotifyModal>

    <NotifyModal
      v-if="isActionWithoutWhenPresetEdited"
      :txt-header="$t('modals.updatePresetGS.saveChanges.title')"
      :txt-description="$t('modals.updatePresetGS.saveChanges.desc', { presetName: currentPreset.name })"
      :txt-button-confirm="$t('modals.updatePresetGS.saveChanges.buttonConfirm')"
      :txt-button-cancel="$t('modals.updatePresetGS.saveChanges.buttonCancel')"
      confirm-class="gf_btn-primary"
      @action="actionWithoutWhenPresetEdited">
    </NotifyModal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PresetItem from './PresetItem.vue';
import LiveThemePreset from './LiveThemePreset.vue';
import { actions, DEFAULT_PRESET, mutations } from '@modules/editor-sidebar';
import { mutations as mutaIframe } from '@/store/iframe/types';
import { mapActions, mapMutations, mapState } from 'vuex';
import type { Preset } from '@/types/global-style';
import NotifyModal from './modal/NotifyModal.vue';
import FeaturePromotionModal from './onboarding/FeaturePromotionModal.vue';
import PopupOnboarding from './onboarding/PopupOnboarding.vue';
import UpgradePlanPopup from './pricing/UpgradePlanPopup.vue';
import type { PresetParams } from '@/types/global-style-http';
import { cloneDeep } from '@/utils/common';
import { $gfLeftSideBar, $gryffBody, $jQuery } from '@/app/index';
import { getNewStyle, MER_MAP } from '@/utils/apply-preset';
import { PRICING_LIMIT_PRESET } from '@/constants/global-style';
import { generateCssString } from '@modules/global-style';
import GuideCustomizeStyle from './guide/GuideCustomizeStyle.vue';
import { actions as commonActions } from '@/store/common/types';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { app } from '@/store';
import HELPER from '@/app/utils/HELPER';
import PresetMixin from '../utils/mixins/Preset';
import emitter from '@/emitter';
import { reRunInit } from '@/modules/gem-meter/GemMeterEngine/Engine/useGemMeterController';
import { isLandingPage } from '@/modules/gem-meter/GemMeterEngine/Engine/useGemMeterStore';

const defaultViewTarget = 'LIST_PRESET';
const SCREENS = {
  listPreset: 'LIST_PRESET',
  editPreset: 'EDIT_PRESET',
  liveThemePreset: 'LIVE_THEME_PRESET',
};

export default defineComponent({
  name: 'ListPreset',
  components: {
    PresetItem,
    LiveThemePreset,
    FeaturePromotionModal,
    GuideCustomizeStyle,
    PopupOnboarding,
    NotifyModal,
    UpgradePlanPopup,
  },
  mixins: [PresetMixin],
  data: () => ({
    showCreate: false,
    isActionWithoutWhenPresetEdited: false,
    dataCallBackWithoutPresetEdited: undefined,
    viewTarget: defaultViewTarget,
    screens: SCREENS,
    txtHeader: 'Delete the Preset',
    txtDesConfirm: '',
    isDeleteConfirmed: false,
    indexDelete: -1,
    modalNotifyApply: '',
    typeModal: {
      applyPreset: 'apply-preset',
      applyPresetCurrent: 'apply-preset-current',
      publishPresetCurrent: 'publish-preset-current',
      applyPresetSelected: 'apply-preset-current',
      publishPresetSelected: 'publish-preset-selected',
    },
    MAX_PRESET_ALLOW: 20,
    PRICING_LIMIT_PRESET: PRICING_LIMIT_PRESET,
  }),
  computed: {
    ...mapState('sidebar', {
      tabs: (state) => (state as any).tabs,
      presetsData: (state) => (state as any).presets,
      isLoadingPreset: (state) => (state as any).isLoadingPreset,
      viewTargetStore: (state) => (state as any).viewTargetPreset,
      currentPreset: (state) => (state as any).currentPreset,
      linkedPresetId: (state) => (state as any).linkedPresetId,
      previewPreset: (state) => (state as any).previewPreset,
    }),
    ...mapState('app', {
      pageInfo: 'pageInfo',
      shopInfo: 'shopInfo',
      shopMeta: 'shopMeta',
      enablePassword: 'enablePassword',
    }),
    isVisiblePopupOnboarding() {
      return (
        this.obGlobalStyle.previewPresetOB === 2 &&
        !this.obGlobalStyle.createNewPreset &&
        this.obGlobalStyle.featurePromotion
      );
    },
    obGlobalStyle() {
      return this.shopMeta.onboardingGlobalStyle;
    },
    presets(): Preset[] {
      let presets = cloneDeep(this.presetsData);
      if (!presets) return [];

      presets = presets.sort(function (a: any, b: any) {
        return a.id - b.id;
      });

      const linkedPresetIndex = presets.findIndex((item: any) => item.id === this.linkedPresetId);
      if (linkedPresetIndex != -1) {
        presets.unshift(presets[linkedPresetIndex]);
        presets.splice(linkedPresetIndex + 1, 1);
      }
      return presets;
    },
    planAlert() {
      return this.$t(
        `sidebarGS.listPreset.limitPresetAlert.${this.shopInfo?.plan}`,
      );
    },
    invalidCreateNewButton() {
      return this.presetsData.filter((element: { destroy: any }) => !element.destroy).length >= this.pricingLimitPreset;
    },
    pricingLimitPreset() {
      const plan = this.shopInfo?.plan;
      const planLimitation = this.shopInfo?.planLimitation[plan];
      if (planLimitation) {
        const { keyFeatures } = planLimitation;
        return keyFeatures?.globalStyle?.nbOfPreset || 20;
      }
      return (PRICING_LIMIT_PRESET as any)[this.shopInfo.plan];
    },
  },
  watch: {
    viewTargetStore(newVal) {
      if (newVal) {
        this.viewTarget = this.viewTargetStore;
      }
    },
    previewPreset(newVal, oldVal) {
      if (Boolean(newVal) === Boolean(oldVal)) return;

      if (newVal) {
        this.previewPresetFunc(this.currentPreset, this.linkedPresetId === this.currentPreset.id);
      } else {
        this.quitPreviewPreset();
      }
    },
  },
  unmounted() {
    if (this.previewPreset) {
      this.quitPreviewPreset();
    }
  },
  mounted() {
    emitter.off('WithoutPresetEdited');
    emitter.on('WithoutPresetEdited', (data: any) => {
      this.isActionWithoutWhenPresetEdited = true;
      this.dataCallBackWithoutPresetEdited = data;
    });

    emitter.off('tryNowOnboarding');
    emitter.on('tryNowOnboarding', () => {
      this.viewTarget = this.screens.liveThemePreset;
      this.setCurrentPreset(this.presets[0]);
    });
  },
  created() {
    this.trackEvent({ eventId: EDITOR_EVENT.GS_TAB_VIEWD });
  },
  methods: {
    ...mapActions('sidebar', {
      previewPresetOB: actions.CREATE_PRESET,
      deletePreset: actions.DELETE_PRESET,
      duplicatePreset: actions.DUPLICATE_PRESET,
      crawlFromLiveTheme: actions.CRAWL_FROM_LIVE_THEME,
      applyPreset: actions.APPLY_PRESET,
      publicPreset: actions.PUBLIC_PRESET,
    }),
    ...mapActions('common', {
      trackEvent: commonActions.TRACK_EVENT,
    }),
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    ...mapMutations('sidebar', {
      setCurrentPreset: mutations.SET_CURRENT_PRESET,
      commitPresetModal: mutations.PRESET_MODAL,
      setPreviewPreset: mutations.SET_PREVIEW_PRESET,
    }),
    ...mapMutations('iframe', {
      ALERT: mutaIframe.ALERT,
    }),
    onOutSide() {
      this.showCreate = false;
      this.hideOverlay();
    },
    editPreset(preset: any) {
      this.viewTarget = this.screens.liveThemePreset;
      this.setCurrentPreset(preset);
      if (this.linkedPresetId === preset.id) {
        this.previewPresetFunc(preset, true);
      }
    },
    turnOnPreview(preset: any) {
      this.setCurrentPreset(preset);
      this.setPreviewPreset(true);
    },
    previewPresetFunc(preset: any, isCurrentLinkedPreset = false) {
      this.setPreviewPreset(true);
      this.setCurrentPreset(preset);
      const $gfFrameContents = $jQuery('#gfFrame').contents();
      if (!isCurrentLinkedPreset) {
        $gfFrameContents.find('body').first().append('<div class="gf-overlayPreviewPreset"></div>');
      } else {
        $gfFrameContents.find('.gf-overlayPreviewPreset').remove();
      }

      const cssString = generateCssString(this.currentPreset);
      $gfFrameContents
        .find('.gryffeditor')
        .append(`<style class="gf_gs-global-style-preview" type="text/css">${cssString}</style>`);
      $gfFrameContents.find('.gryffeditor .gf_gs-global-style').attr('type', 'text/plain');

      // ===== GemMeter Feature ===== //
      if (isLandingPage()) {
        this.$nextTick(() => {
          setTimeout(() => {
            reRunInit();
          }, 100);
        });
      }
      // =========================== //
      this.handlePreviewPresetNotYetApplyPreset($gfFrameContents);
    },

    handlePreviewPresetNotYetApplyPreset($gfFrameContents: any) {
      if (this.linkedPresetId > 0) return;
      const allStyleKeys = (app as any).$store.getters['editor/GET_STYLE_SETTINGS']();
      for (const keyStyle of allStyleKeys) {
        this.handlePreviewModifyItemStyle({ keyStyle, gfFrameContents: $gfFrameContents });
      }
    },

    previewModifyStyleStore(params: { key: string; value: string; $gfFrameContents: any }, fieldValues: any = []) {
      const keyParts: any = params.key;
      const $gfFrameContents: any = params.$gfFrameContents;
      const merId = HELPER.detachKeyDataSetting(keyParts, 'id');
      if (merId) {
        const $mer = $gfFrameContents.find(merId);
        if (!$mer || !$mer.length) {
          return params.value;
        }
        const merKey = HELPER.getDataKeyMER($mer);
        return this.previewModifyStyle(params.value, merKey, merId, fieldValues);
      }
      return params.value;
    },

    previewModifyStyle(newStyleValue: any, merKey: any, merId: any, fieldValues: any = []) {
      const merSettingGroups = Object(MER_MAP)[merKey]?.settingGroups;
      let fieldLength = fieldValues.length;
      let fieldKeys: any = '';
      if (!(fieldValues && fieldLength > 0)) {
        fieldValues = (merSettingGroups && Object.values(merSettingGroups)) || [];
        fieldKeys = merSettingGroups && Object.keys(merSettingGroups);
      }
      fieldLength = fieldValues.length;
      const $mdSettings = $jQuery('#gfLeftSideBar').find('#md-settings');
      const isOpenSetting = $mdSettings.hasClass('active');
      for (let index = 0; index < fieldLength; index++) {
        if (isOpenSetting && fieldKeys) {
          const fieldKey: any = fieldKeys[index];
          const valInputGs = $mdSettings.find(`#${fieldKey}, #${fieldKey}-type`).val();
          if (!valInputGs) {
            continue;
          }
        }
        const fieldValue: any = fieldValues[index];
        for (const property in fieldValue) {
          const fieldItem = fieldValue[property];
          if (fieldItem) {
            const selector: any = (fieldItem && fieldItem.selector) || '';
            const cssAttrs: any = fieldItem.cssAttr;
            newStyleValue = getNewStyle(newStyleValue, { merId, selector, cssAttrs });
          }
        }
      }

      return newStyleValue;
    },
    handlePreviewModifyItemStyle(params: any) {
      const keyStyle = params.keyStyle;
      const merKey = params.merKey;
      const merId = params.merId;
      const fieldValues = params.fieldValues ? params.fieldValues : [];
      let $gfFrameContents: any = params.gfFrameContents;
      if (!$gfFrameContents) {
        $gfFrameContents = $jQuery('#gfFrame').contents();
      }
      const oldStyleValue = (app as any).$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyStyle);

      // Backup old Style
      (app as any).$store.commit('editor/SET_BEFORE_STYLE_PREVIEW_MODE', {
        id: keyStyle,
        value: oldStyleValue,
      });

      // modify old style
      const idStyle =
        typeof keyStyle === 'string' ? keyStyle.replace('-row', '').replace('-element', '').replace('-module', '') : '';
      let newStyleValue = '';

      if (merKey && merId) {
        newStyleValue = this.previewModifyStyle(oldStyleValue, merKey, merId, fieldValues);
      } else {
        newStyleValue = this.previewModifyStyleStore(
          { key: keyStyle, value: oldStyleValue, $gfFrameContents },
          fieldValues,
        );
      }

      // replace old style block

      $gfFrameContents.find(`#${idStyle} .style`).html(newStyleValue);
      (app as any).$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyStyle,
        value: newStyleValue,
      });

      return newStyleValue;
    },
    discardCurrentPreset() {
      const preset = this.presets.find((item: any) => item.id == this.currentPreset.id);
      if (preset) {
        this.setCurrentPreset(preset);
      }
    },
    actionWithoutWhenPresetEdited(type: string) {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_DISCARD_BUTTON_CLICKED });
      this.isActionWithoutWhenPresetEdited = false;

      if (['confirm', 'cancel'].includes(type)) {
        if (type === 'confirm') {
          (app as any).$store.state['app']['showOverlayApp'] = true;
          this.modalUpdateCurrentPreset();
          (app as any).$store.state['app']['showOverlayApp'] = false;
        }

        if (type === 'cancel') {
          this.discardCurrentPreset();
          this.ALERT({
            show: true,
            title: '',
            message: `Successfully <span class="typo-semibold">discarded</span> all the changes in <b>${this.currentPreset.name}</b>`,
            typeAlert: 'success',
          });
        }
        emitter.off('CallBackWithoutPresetEdited');
        emitter.emit('CallBackWithoutPresetEdited', this.dataCallBackWithoutPresetEdited);
        this.quitPreviewPreset();
        this.viewTarget = this.screens.listPreset;
      }
    },
    onBack(isEditedCurrentPreset: boolean) {
      if (!isEditedCurrentPreset) {
        this.viewTarget = this.screens.listPreset;
        this.quitPreviewPreset();
      }
      this.isActionWithoutWhenPresetEdited = isEditedCurrentPreset;
    },
    quitPreviewPreset() {
      this.setPreviewPreset(false);
      const $gfFrameContents = $jQuery('#gfFrame').contents();
      $gfFrameContents.find('.gryffeditor .gf_gs-global-style-preview').remove();
      $gfFrameContents.find('.gf-overlayPreviewPreset').remove();
      $gfFrameContents.find('.gryffeditor .gf_gs-global-style').attr('type', 'text/css');
      this.handleStyleQuitPreview($gfFrameContents);
    },
    handleStyleQuitPreview($gfFrameContents: any) {
      if (this.linkedPresetId > 0) return;
      const allStyleKeys = (app as any).$store.state['editor']['beforeStylePreviewModeGlobalStyle'];
      for (const keyStyle in allStyleKeys) {
        const value = (app as any).$store.getters['editor/GET_BEFORE_STYLE_PREVIEW_MODE'](keyStyle);
        const idStyle =
          typeof keyStyle === 'string'
            ? keyStyle.replace('-row', '').replace('-element', '').replace('-module', '')
            : '';

        $gfFrameContents.find(`#${idStyle} .style`).html(value);
        (app as any).$store.commit('editor/SET_DATA_SETTINGS', {
          id: keyStyle,
          value: value,
        });
      }
    },
    toggleNewPresetPopup() {
      this.showCreate = !this.showCreate;
      this.trackEvent({ eventId: EDITOR_EVENT.GS_CREATE_NEW_PRESET_POPUP_CLICKED });
      const _this = this;
      if (this.showCreate) {
        this.showOverlay();
        setTimeout(function () {
          $gryffBody()
            .find('.backgroundAdv')
            .off('mousedown.removeBackground')
            .on('mousedown.removeBackground', function () {
              _this.showCreate = false;
              _this.hideOverlay();
            });
        }, 0);
      } else {
        _this.hideOverlay();
      }
    },
    showOverlay() {
      if ($gfLeftSideBar()?.data('gfleftsidebar')) {
        $gfLeftSideBar().data('gfleftsidebar').onBackgroundIframe('backgroundAdv');
      }
    },
    hideOverlay() {
      if ($gfLeftSideBar()?.data('gfleftsidebar')) {
        $gfLeftSideBar().data('gfleftsidebar').offBackgroundIframe('backgroundAdv');
      }
    },
    async processCrawlPreset(dom: string, isThisPage: boolean) {
      let messageSuccess = 'preset from your Shopify Theme successfully';
      let messageInfo = 'preset from Shopify Theme';

      if (isThisPage) {
        messageSuccess = 'preset from the current page';
        messageInfo = 'preset from the current page';
      }

      this.ALERT({
        show: true,
        title: 'Importing',
        message: messageInfo,
        typeAlert: 'info',
        delay: 'infinity',
      });

      try {
        const res: any = await this.crawlFromLiveTheme(dom);
        if (res.status === 'success') {
          emitter.emit('googleFontsLoaded');
          await this.publicPreset({ preset: res.data });
  
          this.ALERT({
            show: true,
            firstTitle: '',
            title: 'Imported',
            message: messageSuccess,
            typeAlert: 'success',
          });
        } else {
          let message = res.message;
          let title = 'Import failed.';
          if (res.errorCode == 'GS00005') {
            title = '';
            message = `Failed to <b>import</b> preset because you already own ${this.pricingLimitPreset} of ${this.pricingLimitPreset > 1 ? 'presets' : 'preset'}.`;
          }
          this.ALERT({
            show: true,
            title: title,
            message: message,
            typeAlert: 'error',
          });
        }
      } catch (error) {
        this.ALERT({
          show: true,
          title: 'Create failed.',
          message: 'Session has expired.',
          typeAlert: 'error',
        });
      }

    },
    async onThisPage() {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_CREATE_FROM_THIS_PAGE_CLICKED });

      const $gfFrame = $jQuery('#gfFrame');
      const $gryBody = $gfFrame.contents().find('html').first();
      const domThisPage = `<html lang="en">${$gryBody.html()}</html>` as string;
      await this.processCrawlPreset(domThisPage, true);
    },
    async onLiveTheme() {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_CREATE_FROM_LIVE_THEME_CLICKED });
      if (this.enablePassword) {
        emitter.emit('toggle-password', {
          source: 'gs-create-preset',
        });

        return;
      }

      await this.processCrawlPreset('', false);
    },
    async onDuplicatePreset(preset: any) {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_DUPLICATE_PRESET_CLICKED });

      this.ALERT({
        show: true,
        title: 'Duplicating',
        message: `preset ${preset.name}`,
        typeAlert: 'info',
        delay: 'infinity',
      });
      try {
        const presetId: any = preset.id;
        const res: any = await this.duplicatePreset({ presetId: presetId });
        if (res.status === 'success') {
          await this.publicPreset({ preset: res.data });
          this.ALERT({
            show: true,
            title: 'Duplicated',
            message: 'preset successfully.',
            typeAlert: 'success',
          });
        } else {
          let title = 'Duplicate failed.';
          let message = res.message;
          if (res.errorCode === 'GS00006') {
            title = '';
            message = this.msgAlreadyDelete(preset);
          }
          if (res.errorCode == 'GS00005') {
            title = '';
            message = `<span class="typo-semibold">Duplicate failed</span> because you already own ${this.pricingLimitPreset} of ${this.pricingLimitPreset > 1 ? 'presets' : 'preset'}.`;
          }
          this.ALERT({
            show: true,
            title: title,
            message: message,
            typeAlert: 'error',
          });
        }
      } catch (e) {
        this.ALERT({
          show: true,
          title: 'Duplicate failed.',
          message: ' Check your internet connection and try again later.',
          typeAlert: 'error',
        });
      }
    },
    async applyCurrentPage(preset: Preset) {
      // eslint-disable-next-line camelcase
      const gId = this.pageInfo?.page?.g_id;
      // eslint-disable-next-line camelcase
      this.trackEvent({ eventId: EDITOR_EVENT.GS_APPLY_PRESET_MORE_OPTIONS_CLICKED });
      this.applyPresetThisPage(gId, preset);
    },
    applyOtherPage(preset: Preset) {
      this.setCurrentPreset(preset);
      this.commitPresetModal(true);
    },
    onDeletePreset(data: any) {
      this.isDeleteConfirmed = true;
      this.txtDesConfirm = `It will delete the Preset ${data.preset.name}. This action cannot be undone.`;
      this.indexDelete = data.index;
    },
    async actionNotify(type: string) {
      if (type === 'cancel' || type === 'close') {
        this.isDeleteConfirmed = false;
      } else {
        const index = this.indexDelete;
        this.isDeleteConfirmed = false;
        const preset = this.presets[index];
        const presetName = preset.name;

        this.ALERT({
          show: true,
          title: 'Deleting',
          message: `preset ${presetName}`,
          typeAlert: 'info',
          delay: 'infinity',
        });

        if (preset.id) {
          try {
            const presetId = preset.id as number;
            const params: PresetParams = {
              presetId: presetId as number,
            };
            const res = await this.deletePreset(params);
            if (res.status === 'success') {
              this.ALERT({
                show: true,
                title: 'Deleted',
                message: `preset ${presetName} successfully.`,
                typeAlert: 'success',
              });
            } else {
              let title = 'Delete failed.';
              let message = res.message;
              if (res.errorCode === 'GS00006') {
                title = '';
                message = this.msgAlreadyDelete(preset);
              }
              this.ALERT({
                show: true,
                title: title,
                message: message,
                typeAlert: 'error',
              });
            }
          } catch (e) {
            this.ALERT({
              show: true,
              title: 'Delete failed.',
              message: ' Check your internet connection and try again later.',
              typeAlert: 'error',
            });
          }
        } else {
          this.presets.splice(index, 1);
          this.ALERT({
            show: true,
            title: 'Deleted',
            message: `preset ${presetName} successfully.`,
            typeAlert: 'success',
          });
        }
      }
      return false;
    },
    onchangeModal(value: string) {
      this.modalNotifyApply = value;
    },
    async createNewPreset() {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_CREATE_NEW_PRESET_CLICKED });

      this.ALERT({
        show: true,
        title: 'Creating',
        message: 'new preset',
        typeAlert: 'info',
        delay: 'infinity',
      });
      
      try {
        const res = await this.previewPresetOB({ preset: cloneDeep(DEFAULT_PRESET), source: 'New Preset' });
        if (res.status === 'success') {
          await this.publicPreset({ preset: res.data });
  
          this.ALERT({
            show: true,
            title: 'Create',
            message: 'new preset successfully.',
            typeAlert: 'success',
          });
        } else {
          let message = res.message;
          let title = 'Create failed.';
          if (res.errorCode == 'GS00005') {
            title = '';
            message = `Failed to <span class="typo-semibold">create</span> preset because you already own ${this.pricingLimitPreset} of presets.`;
          }
          this.ALERT({
            show: true,
            title: title,
            message: message,
            typeAlert: 'error',
          });
        }
      } catch (error) {
        this.ALERT({
          show: true,
          title: 'Create failed.',
          message: 'Session has expired.',
          typeAlert: 'error',
        });
      }
    },
  } as any,
});
</script>

<style lang="scss">
.limit-preset-tooltip {
  @apply rounded  leading-[18px] font-medium text-xs w-[248px];
  padding: 4px 4px 10px !important;
  color: theme('colors.white') !important;
  background-color: theme('colors.tooltip') !important;
  max-width: 248px !important;
  margin-left: 20px !important;
}
</style>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.preset-container {
  height: 100%;
}

.transform-y {
  transform: scaleY(-1);
}

.footer {
  position: absolute;
  bottom: 0;
  @include flex-center;
  height: 75px;
  background: $black;
  box-sizing: border-box;
  border-radius: 3px;
  width: 100%;
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;

  .create--options {
    z-index: 99;
    width: 174px;
    bottom: 65px;
    position: absolute;
    background: #323232;
    box-shadow: 0px 12px 38px rgba(34, 34, 34, 0.0393604), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545),
      0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455),
      0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14);
    border-radius: 3px;

    .option {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
      height: 32px;
      padding: 10px 0 0 37px;
      margin: 4px;

      &:hover {
        background: $black3;
        border-radius: $radius;
      }
    }
  }

  .preset--create {
    color: #e2e2e2;
    position: relative;
    height: 40px;
    border: 1px dashed #494949;
    width: 100%;

    .btn-create--preset {
      background: none;
      border: none;
      color: #fff;
    }

    .label {
      @include flex-center;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      flex: none;
      order: 1;
      flex-grow: 0;
      margin: 0 8px;
      height: 40px;

      .plus {
        margin-right: 8px;
      }

      .arrow {
        margin-left: 8px;
      }
    }
  }
}

.gf__list--preset {
  border-radius: 3px 3px 0 0;
  height: calc(100% - 120px);
  margin-top: 16px;
}

.scrollBody {
  height: 100%;
  display: flex;
  flex-direction: column;

  .body {
    flex: 1;
  }
}

.gf_preset {
  &-skeleton {
    &_container {
      width: 100%;
      padding: 0 12px;
    }
    width: 100%;
    margin-bottom: 16px;
    cursor: pointer;
    height: 162px;
    border: 1px solid #323232;
    border-radius: 3px;
    cursor: not-allowed;
  }
}
</style>
